var screenW=innerWidth/30;
var screenH=window.innerHeight;
export {screenW,screenH};


// WEBPACK FOOTER //
// ./src/util/os.js